<template>
  <div :class="{'modal': true, 'is-active': alert_modal_flag}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-text="title"></p>
        <button class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body" v-html="content"></section>
      <footer class="modal-card-foot">
        <button class="button is-success" v-text="button_text" @click="closeModal()"></button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      alert_modal_flag: false,
      title: '',
      content: '',
      button_text: '',
      event_bus_alert_modal: ''
    }
  },
  mounted () {
    this.event_bus_alert_modal = this.$geb.getFilteredBus({id: 'alert_modal'}).subscribe(eventData => {
      this.alert_modal_flag = true
      this.title = eventData.title
      this.content = eventData.content
      this.button_text = eventData.button_text
    })
  },
  methods: {
    closeModal () {
      this.alert_modal_flag = false
      this.title = ''
      this.content = ''
      this.button_text = ''
    }
  },
  beforeDestroy () {
    if (this.event_bus_alert_modal) {
      this.event_bus_alert_modal.unsubscribe()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/components/AlertModal.vue